import { Component, Input } from "@angular/core";
import { Area } from "@Core/models/codegen/configuration.models";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    standalone: false,
    selector: 'select-area-modal',
    templateUrl: './select-area-modal.component.html',
})
export class SelectAreaModalComponent {
    @Input() selectedAreaAliasOrName: string;
    @Input() areas: Area[] = [];

    constructor(public activeModal: NgbActiveModal) { }

    onCancel(): void {
        this.activeModal.dismiss();
    }
};